import AdvancedSearch from '@nile/components/src/Components/AdvancedSearch/AdvancedSearch';
import {
  onAttributeSelect,
  onValueSearch
} from '@nile/components/src/Pebbles/AdvancedWorklogFilter';
import React from 'react';
import { injectIntl } from 'react-intl';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';

function ConditionalPricingQueryBuilderForm(props) {
  const { intl, currentModule = 'ticket', flags } = props;

  return (
    <AdvancedSearch
      {...props}
      currentModule={currentModule}
      onAttributeSelect={onAttributeSelect}
      onValueSearch={onValueSearch}
      isNewBuilder={flags?.newRuleBuilder}
    />
  );
}

export default injectIntl(withLDConsumer()(ConditionalPricingQueryBuilderForm));
